import { render, staticRenderFns } from "./UserTrainingCourseAdd.vue?vue&type=template&id=53c3d627&"
import script from "./UserTrainingCourseAdd.vue?vue&type=script&lang=js&"
export * from "./UserTrainingCourseAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports